// extracted by mini-css-extract-plugin
module.exports = {"loginLayout":"mAXSd","header":"tqJdD","footer":"jVFal","footerSupport":"gbOXu"};